import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Attribute`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Data Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`cancel_url`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The relative URL of the page that PayPal will redirect to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is `}<inlineCode parentName="td">{`https://www.example.com/paypal/action/cancel.html`}</inlineCode>{`, the relative URL is `}<inlineCode parentName="td">{`paypal/action/cancel.html`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`error_url`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The relative URL of the transaction error page that PayPal will redirect to upon payment error. If the full URL to this page is `}<inlineCode parentName="td">{`https://www.example.com/paypal/action/error.html`}</inlineCode>{`, the relative URL is `}<inlineCode parentName="td">{`paypal/action/error.html`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`return_url`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The relative URL of the final confirmation page that PayPal will redirect to upon payment success. If the full URL to this page is `}<inlineCode parentName="td">{`https://www.example.com/paypal/action/return.html`}</inlineCode>{`, the relative URL is `}<inlineCode parentName="td">{`paypal/action/return.html`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      